module.exports = __webpack_public_path__ + "assets/img/logo.ca6f9c59.png";